import { FC } from 'react';
import { ReactSVG } from 'react-svg';

import { LogoWrapper } from './Logo.styled';

export const Logo:FC = () => (
  <LogoWrapper>
    <ReactSVG src="/logo-hotelspot.svg" shapeRendering={1} />
  </LogoWrapper>
);
